import { DOMParser } from 'xmldom';
/**
 * We're using a custom DOMParser to support React-Native apps, which don't necessarily have access
 * to the standard Typescript DOMParser implementation available in browsers.
 *
 * (!) The `Document` object created by xmldom.DOMParser here is only compatible up to W3C DOM level2.
 * This limits the methods available to it, e.g `querySelector` is not available. However, the Typescript
 * compiler doesn't understand this, and you will see those methods in autocomplete. Use the link below
 * as a guide for what methods are available.
 * see https://www.npmjs.com/package/xmldom
 */
const divElementFromScript = script => {
    if (!script) {
        return null;
    }
    return new DOMParser()
        .parseFromString(script, 'text/html')
        .getElementsByTagName('div')
        /**
         * `item(index: int)` is crash-safe; it returns null on index-out-of-bounds
         * see https://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
         */
        .item(0);
};
export const divAttributeForScriptWithKey = (script, key) => {
    const div = divElementFromScript(script);
    return div && div.getAttribute(key);
};
/**
 * Parses the special script for the `card_information` step into a useable payload.
 *
 * @param script the `step.script` from the `card_information` step
 * @returns a `IScriptPayload` representation of the payload (`data-react-props`) data
 */
export const payloadFromScript = script => {
    const div = divElementFromScript(script);
    const props = div && div.getAttribute('data-react-props');
    const json = !!props && JSON.parse(props);
    return !!json ? json : null;
};
